export const MODAL_TYPE_READONLY_MODE = 'readonly-mode-modal';
